import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Slide, Dialog, Button } from '@mui/material';
import ReclamosDetails from './TramitesDetails';
import { searchTramites, getFavoritos, dejarDeSeguirTramite } from "../../service/service.supersalud";
import Spinner from '../templates/Spinner'
import Image from "react-bootstrap/Image";
import logo from "./../../images/logo.png";
import TramitesDetails from './TramitesDetailsMovil';
import ListraTramitesMovil from './ListaTramitesMovil';
import CustomTable from '../commons/CustomTable'
import { getDatosReclamosList, tableHeadCells, actionsMonitoreo, ordenarFechas, sinResultados } from '../commons/utils';
import DecisionModal from '../commons/DecisionModal';
import ModalSolicitudes from '../commons/ModalSolicitudes';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const options = {
    rowsPerPageOptions: [1, 5, 10, 15, 100],
    selectableRowsHeader: false,
    selectableRows: "none",
    filter: true,
    search: true,
    print: true,
    viewColumns: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    download: false,
    enableNestedDataAccess: '.',
};

const optionsMobile = {
    rowsPerPageOptions: [1, 5, 10, 15, 100],
    selectableRowsHeader: false,
    selectableRows: "none",
    filter: false,
    search: false,
    print: false,
    viewColumns: false,
    filterType: 'dropdown',
    responsive: 'vertical',
    download: false,
    enableNestedDataAccess: '.',
}

const TramitesMonitoreo = props => {

    const { user, userLogOut, wildcard, rut, userLoggedIn, type, searchNow, reload } = props;
    const history = useHistory();
    const classes = useStyles();
    const [recActivo, setrecActivo] = useState([]);
    const [solActiva, setSolActiva] = useState('')
    const [tramites, setTramites] = useState([])
    const [openModal, setOpenModal] = useState({ open: false });
    const [searchWild, setsearchWild] = useState(false);
    const [loading, setLoading] = useState(true);
    const { innerWidth: width/*, innerHeight: height*/ } = window;
    const [firstLoad, setFirstLoad] = useState(true);

    const [showModalDecision, setShowModalDecision] = useState(false)
    const [tramiteMonitoreo, setTramiteMonitoreo] = useState('')

    const [modalBody, setModalBody] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modalAccept, setModalAccept] = useState('');
    const [modalCancel, setModalCancel] = useState('');

    const [auxTramites, setAuxTramites] = useState([])

    const [showModalSolicitudes, setShowModalSolicitudes] = useState(false)

    const submitDecisionModal = (tramite) => {
        stopFollowTramite(tramite)
    }

    const openDecisionModal = (tramite) => {
        setTramiteMonitoreo(tramite)
        setShowModalDecision(true)
    }

    const closeDecisionModal = () => {
        setTramiteMonitoreo('')
        setShowModalDecision(false)
    }

    const handleAction = (menu, item) => {
        if (menu.action === 'verDetalle') {
        
            if (item.clasificacion === 'gestion_externa' || item.clasificacion === 'gestion_interna') {
                setSolActiva(item)
                setShowModalSolicitudes(true)
            } else {

                let aux = {
                    ...item,
                    run_rec: item.rut_reclamante
                }
                setrecActivo(aux)
                setOpenModal({ open: true });

            }

        } else if (menu.action === 'dejar_seguir') {
            setModalBody('¿Desea dejar de monitorear éste trámite?')
            setModalTitle('Monitorear trámite')
            setModalAccept('Dejar de monitorear')
            setModalCancel('Cancelar')
            openDecisionModal(item)
        }
    };

    const dataIsInArray = (data, array, index) => {

        let aux = false

        if (index === 0) {

        } else {
            array.map((item, indice) => {
                if (item === data) {
                    aux = true
                }
                return null
            })
        }

        return aux

    }

    const getTramitaciones = () => {
        let aux = []
        tramites.map((item, index) => {

            if (!dataIsInArray(item.tramitacion, aux, index)) {
                aux.push(item.tramitacion)
            }
            return null
        })
        return aux
    }

    const getReclamados = () => {
        let aux = []
        tramites.map((item, index) => {
            if (!dataIsInArray(item.reclamado, aux, index)) {
                aux.push(item.reclamado)
            }
            return null
        })
        return aux
    }

    const getEtapas = () => {
        let aux = []
        tramites.map((item, index) => {

            if (!dataIsInArray(item.etapa_actual, aux, index)) {
                aux.push(item.etapa_actual)
            }
            return null
        })

        return aux
    }

    const validaciones = [
        {
            type: 'dateRange',
            target: 'fechaIngreso',
            title: 'Fecha',
        },
        {
            type: 'select',
            target: 'tramitacion',
            title: 'Tipo Trámite',
            options: getTramitaciones()
        },
        {
            type: 'select',
            target: 'reclamado',
            title: 'Entidad',
            options: getReclamados()
        },
        {
            type: 'select',
            target: 'etapa_actual',
            title: 'Etapa',
            options: getEtapas()
        },
    ];

    const closeModalSolicitud = () => {
        setShowModalSolicitudes(false)
        setSolActiva('')
    }

    const handleClose = () => {
        setOpenModal({ open: false });
    };


    const openModalHandler = fila => {
        let aux = {
            ...fila,
            run_rec: fila.rut_reclamante
        }
        setrecActivo(aux)

        setOpenModal({ open: true });
    };

    const openModalSolicitudes = row => {
      
        setSolActiva(row)
        setShowModalSolicitudes(true)

    }

    const logout = () => {
        userLogOut();
        history.push("/login")
    }

    const openModalMovil = item => {
        let aux = {
            ...item,
            run_rec: item.rut_reclamante
        }
        setrecActivo(aux)
        setOpenModal({ open: true });

    }

    const stopFollowTramite = async (tramite) => {
        const resp = await dejarDeSeguirTramite(user, logout, userLoggedIn)(JSON.stringify({ indice: tramite.ux, folio: tramite.folio }));
        if (resp.status === 204) {
            closeDecisionModal()
            getTramitesByRut(user.rut)
        }
    }

    const getTramitesByRut = async (rut) => {

        if (rut) {
            const resp = await getFavoritos(user, logout, userLoggedIn)('?monitoreo=false')

            const results = await resp.json()

            let auxArray = []
            results.map((obj, index) => {

                let auxObj = {
                    ...obj,
                    etapa_actual_tabla: obj.fase.nombre
                }
                auxArray.push(auxObj)
            })

           
            ordenarFechas(auxArray)

            setTramites(
                auxArray.map((item, index) => {
                    return getDatosReclamosList(item, false)
                })

            )

            setAuxTramites(
                auxArray.map((item, index) => {
                    return getDatosReclamosList(item, false)
                })
            )

        }

        setFirstLoad(false)

        setLoading(false)

    }

    const buscarTramites = wildcard => {
        let auxARr = []
        tramites.map((item, index) => {
            if (
                item.folio.toString().toLowerCase().includes(wildcard) ||
                item.nombre_raw.toString().toLowerCase().includes(wildcard) ||
                item.fecha_ingreso.toString().toLowerCase().includes(wildcard) ||
                item.run_rec.toString().toLowerCase().includes(wildcard) ||
                item.tipo_reclamo.toString().toLowerCase().includes(wildcard) ||
                item.reclamado.toString().toLowerCase().includes(wildcard) ||
                item.etapa_actual.toString().toLowerCase().includes(wildcard) ||
                (item.vencimiento_raw ? item.vencimiento_raw.toString().toLowerCase().includes(wildcard) : null)
            ) {
                auxARr.push(item)
            }
            return null
        })

        setAuxTramites(auxARr)
        setLoading(false)
    }

/*     const getTramites = async (wildcard) => {
        let resp = undefined;
        setLoading(true)
        if (wildcard !== '') {
            setsearchWild(true)

            resp = await searchTramites(user, logout, userLoggedIn)(JSON.stringify({
                ...(wildcard && { wildcard })
            }));
            setsearchWild(false)
        }

        const resp_status = (resp || {}).status;
        if (resp_status === 200) {
            const results = await resp.json()
            let auxArray = []
            results["results"].map((obj, index) => {

                let auxObj = {
                    ...obj,
                    etapa_actual_tabla: obj.fase.nombre
                }
                auxArray.push(auxObj)
            })

            ordenarFechas(auxArray)
            setTramites(
                auxArray.map((item, index) => {
                    return getDatosReclamosList(item, false)
                })
            )

        }
        setLoading(false)
    } */

    useEffect(
        () => {
            setLoading(true)
            getTramitesByRut(rut)
        }, [])

    useEffect(
        () => {
            setLoading(true)
            if (!firstLoad) {
                let auxWildCard = { value: wildcard, type: type }
                window.gtag("event", "listar_tramite", {
                    event_category: "access",
                    event_label: "listado"
                });
                if (user === null) {
                    return history.push("/");
                } else {

                    if (wildcard !== '') {
                        /* getTramites(auxWildCard) */
                        buscarTramites(wildcard)
                    } else {
                        getTramitesByRut(rut)
                    }
                }
            } else {
                setFirstLoad(false)
            }
        }, [wildcard, searchNow, reload]
    );

    return (
        <Fragment>
            <DecisionModal
                title={modalTitle}
                body={modalBody}
                accept={modalAccept}
                cancel={modalCancel}
                closeModal={closeDecisionModal}
                submitModal={submitDecisionModal}
                openDialog={showModalDecision}
                tramite={tramiteMonitoreo}
                hideFields={true}
            />
            <Grid
                container
                direction="row"
                justifyContent="center"

                alignItems="center"
            >
                {loading ? <Spinner /> : null}
                {
                    auxTramites && auxTramites.length > 0 ?
                        width > 500 ?
                            < Grid className={classes.section}  >

                            
                                <CustomTable
                                    headCells={tableHeadCells}
                                    rows={auxTramites}
                                    /*  title={'Trámites Monitoreados'} */
                                    /* validation={validaciones} */
                                    search={true}

                                    actions={actionsMonitoreo}
                                    validation={validaciones}
                                    handleAction={handleAction}
                                    openModal={openModalHandler}
                                    openModalSolicitudes={openModalSolicitudes}

                                />

                            </Grid>
                            :
                            < Grid style={{ width: '100%' }} className={classes.section}  >


                                <ListraTramitesMovil
                                    data={auxTramites}
                                    openModalMovil={openModalMovil}
                                    openDecisionModal={openDecisionModal}
                                    setModalBody={setModalBody}
                                    setModalTitle={setModalTitle}
                                    setModalAccept={setModalAccept}
                                    setModalCancel={setModalCancel}
                                    openModalSolicitud={openModalSolicitudes}
                                    
                                />

                            </Grid>
                        :
                        loading ? null:sinResultados()
                }

            </Grid>
            {
                searchWild ?
                    <Spinner />
                    :
                    null
            }
            <Dialog fullScreen open={openModal.open} onClose={handleClose} TransitionComponent={Transition}>
                <Fragment>
                    <header className="d-flex header-resposive-ss">
                        <Image src={logo} className="logo-responsive" />
                        <Button color="inherit" onClick={handleClose} >
                            <ExitToAppOutlinedIcon style={{ transform: "rotate(-180deg)" }} />
                            Volver
                        </Button>
                    </header>
                    {width > 500 ?
                        /* muestra los detalles vanilla en modal */

                        <ReclamosDetails
                            {...{
                                user: user,
                                recActivo: recActivo,
                                openModal,
                                userLogOut,
                                userLoggedIn
                            }} />
                        :
                        /* muestra los detalles en version telefono movil en modal */
                        <TramitesDetails
                            {...{
                                user: user,
                                recActivo: recActivo,
                                openModal,
                                userLogOut,
                                userLoggedIn
                            }}
                        />
                    }
                </Fragment>
            </Dialog>
            <Dialog fullScreen open={showModalSolicitudes} onClose={closeModalSolicitud} TransitionComponent={Transition}>
                <Fragment>
                    <header className="d-flex header-resposive-ss">
                        <Image src={logo} className="logo-responsive" />
                        <Button color="inherit" onClick={closeModalSolicitud} >
                            <ExitToAppOutlinedIcon style={{ transform: "rotate(-180deg)" }} />
                            Volver
                        </Button>
                    </header>
                    {
                        /* muestra los detalles vanilla en modal */
                        <ModalSolicitudes
                            user={user}
                            recActivo={solActiva}
                            openModal={showModalSolicitudes}
                            userLogOut={userLogOut}
                            userLoggedIn={userLoggedIn}
                        />


                    }
                </Fragment>
            </Dialog>
        </Fragment >
    );
}

export default TramitesMonitoreo;

const useStyles = makeStyles((theme) => ({
    appBarTop: {
        backgroundColor: '#fff',
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    section: {
        marginBottom: '5%'
    }
}));
